import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Analytics from 'analytics-opencare';
import { Form } from 'opencare-crown';
import { useAnalyticsService } from 'services/AnalyticsService';

import SingleSelect from '../../../../../common/components/SingleSelect/SingleSelect';
import {
  OptionBlock,
  Subtitle,
  Title,
} from '../../../../../common/styled-components';
import { useFunnelStorage } from '../../../../../funnel/storage/Storage';
import { StepWrapper } from '../../../../styled-components';
import { CONCIERGE_KEY, generateStepAnalytics } from '../../../../utils';
import { treatments } from '../../constants';

const analytics = new Analytics();

const Treatment = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const [treatmentForm] = Form.useForm();

  const savedReason = storage.get(CONCIERGE_KEY.REASON);

  const [selectedTreatment, setSelectedTreatment] = useState(
    get(savedReason, 'treatments') ? savedReason.treatments[0] : {},
  );

  useEffect(() => {
    if (storage.loading) {
      return;
    }

    analytics.trackPageView({
      pageType: analytics.pageTypes.CONCIERGE,
      pageName: 'concierge_services',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, [storage.loading]);

  const selectTreatment = choice => {
    setSelectedTreatment(choice);
    treatmentForm.submit();
  };

  const complete = () => {
    analytics.trackClick({
      pageType: analytics.pageTypes.CONCIERGE,
      pageName: 'concierge_services',
      name: 'wizard',
      section: 'reason-dentist',
      position: [treatments.findIndex(opt => opt.id === selectedTreatment.id)],
      ...generateStepAnalytics(position, storage, {
        'dentist-service': selectedTreatment.data || selectedTreatment.title,
      }),
    });

    const previouslySaved = storage.get(CONCIERGE_KEY.REASON);
    const savedData = {
      ...previouslySaved,
      reasonPartnerId: selectedTreatment.reasonPartnerId,
      treatments: [
        {
          title: selectedTreatment.data || selectedTreatment.title,
          id: selectedTreatment.id,
        },
      ],
      urgentReason: null,
    };

    storage.save(CONCIERGE_KEY.REASON, savedData, true);
    moveToNextStep();
  };

  return (
    <div data-testid="substep-treatment" id="substep-treatment">
      <Title>Select the treatment you need.</Title>
      <Subtitle>
        We'll filter for dentists who specialize in specific treatments and
        technology.
      </Subtitle>
      <StepWrapper>
        <Form form={treatmentForm} onFinish={complete}>
          <OptionBlock row={4}>
            {treatments.map((treatment, i) => (
              <SingleSelect
                key={treatment.id}
                name="treatments"
                id={treatment.id}
                title={treatment.title}
                describedBy="title"
                tooltip={treatment.description}
                onChange={() => selectTreatment(treatment, i)}
                selected={selectedTreatment.title === treatment.title}
              />
            ))}
          </OptionBlock>
        </Form>
      </StepWrapper>
    </div>
  );
};

Treatment.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default Treatment;
